interface Plan {
  NomePlano?: string;
  Status?: string;
  hasBonus?: boolean;
  bonusEndDate?: string;
  currentPeriodEnd?: string;
}

export function hasCourseAccess(plan: Plan) {
  const now = Date.now();
  const bonusEnd = plan.bonusEndDate || plan.currentPeriodEnd;
  const periodIsActive = !!plan.currentPeriodEnd && new Date(plan.currentPeriodEnd).getTime() > now;
  const bonusIsActive = (plan.hasBonus || plan.Status === 'bonus') &&
    !!bonusEnd && new Date(bonusEnd).getTime() > now;
  const premiumIsActive = plan.NomePlano?.toLowerCase() === 'premium' &&
    (plan.currentPeriodEnd ? periodIsActive : ['paid', 'pago'].includes(plan.Status || ''));
  return bonusIsActive || premiumIsActive;
}

